import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import CodeBlock from '../CodeBlock';

type PackageManager = 'yarn' | 'npm';

interface IInstallationProps {
	manager: PackageManager;
}
export const Installation = ({ manager }: IInstallationProps) => {
	return (
		<Box w="100%" mr="10px">
			<Text my="5px">
				Install with{' '}
				<Text as="span" fontWeight={'black'}>
					{manager}
				</Text>
			</Text>
			<CodeBlock
				text={manager === 'npm' ? 'npm install ms-react-progress-bar' : 'yarn add ms-react-progress-bar'}
				language="bash"
			/>
		</Box>
	);
};
